module.exports = __webpack_public_path__ + "img/logo-presse-les-echos_200x200.7cb78a68.jpg";